import type { CanvasPayload } from "../types"
import styles from "../styles/widgetFin.module.css"

function labelFor(payload: CanvasPayload): string {
  switch (payload.kind) {
    case "basket":
      return "Cart"
    case "build_step": {
      // Show the customer where they are in the build so the chip means
      // something — "Anthracite Grey · size" reads better than just
      // "Anthracite Grey build" repeated four times as the user advances.
      const { color } = payload.data.partialSummary
      const stepLabel = STEP_LABEL[payload.data.nextStep.axis] ?? "build"
      return `${color} · ${stepLabel}`
    }
    case "build_summary":
      return `${payload.data.variantTitle.split("/")[0].trim()} kit`
    case "product":
      return payload.data.name
    case "products":
      return `${payload.data.length} products`
    case "color":
      return payload.data.name
    case "colors":
      return `${payload.data.length} colors`
    case "video":
      return "Video"
    case "tracking":
      return `Order ${payload.data.orderNumber}`
    case "knowledge":
      return payload.data.query ? `"${payload.data.query}"` : "Guide"
    case "size_guide":
      return `${payload.data.recommendedSize} kit`
  }
}

const STEP_LABEL: Record<string, string> = {
  size: "size",
  sprayer: "sprayer",
  finish: "finish",
  paintCondition: "paint",
  clearcoat: "clearcoat",
}

export function HistoryStrip({
  payloads,
  activeId,
  onSelect,
}: {
  payloads: CanvasPayload[]
  activeId: string | null
  onSelect: (id: string) => void
}) {
  if (payloads.length <= 1) return null   // hide when there's only the active payload
  return (
    <div className={styles["history-strip"]} role="tablist" aria-label="Canvas history">
      {payloads.map((p) => {
        const isActive = p.id === activeId
        return (
          <button
            key={p.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles["history-chip"]}${isActive ? " " + styles["history-chip-active"] : ""}`}
            onClick={() => onSelect(p.id)}
          >
            {labelFor(p)}
          </button>
        )
      })}
    </div>
  )
}
